
const userRoleConstants = {
  GUEST: 1,
  CUSTOMER_SERVICE: 2,
  PERSONAL_TRAINER: 3,
  MEMBER: 4,
  ADMIN: 5
}

const userConstants = {
  userRoleConstants
}

export default userConstants;